<template>
  <v-container
    style="max-width: 100vw;
    padding: 0;"
  >
    <div
      style="position: relative; top: 26vh; margin: auto; width: 420px;
        left: 25%; box-shadow: 0 0 10px rgba(150,150,200, 0.3); display:flex;"
    >
      <div style="padding:20px; background:#6dd0f7; min-width:175px;">
        <img src="imgs/logo.png" style="width:100px; margin-left:20px;" />
        <div style="padding: 10px; line-height:16px; margin-top:15px;">
          TAHUN<br />
          ANGGARAN
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              color="#6dd0f7"
              v-on="on"
              style="font-weight:bold; font-size:xx-large; padding:0; margin-left:10px; padding-right:5px;"
              elevation="0"
            >
              {{ tahun }}
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              v-for="t in pilihanTahun"
              :key="t"
              @click="tahunAnggaranClick(t)"
            >
              {{ t }}
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div
        style="padding: 20px; background: white; display: block; width: 250px; border-radius:5px;"
      >
        <div
          style="font-family: Raleway;
                font-size: x-large;
                border-left: 20px solid #6dd0f7;
                padding-left: 20px;
                line-height: 20px;"
        >
          RAMPUNG<br />
          BAYAR
        </div>
        <br />
        <div
          style="color: gray;
                    margin-top: -15px;
                    margin-bottom: 20px;
                    font-size: small;
                    line-height: 15px;"
        ></div>
        <Input
          label="Username"
          :value.sync="forms.username"
          class="inline"
          left-icon="face"
          width="100%"
        />
        <Input
          label="Password"
          :value.sync="forms.password"
          type="password"
          left-icon="lock"
          width="100%"
        />
        <br />
        <v-btn color="primary" @click="submit" style="width:210px">Login</v-btn>
        <v-btn
          color="primary"
          text
          small
          @click="showTpLogin = true"
          style="width:210px"
          >Via TataPraja</v-btn
        >
      </div>

      <div
        class="logo"
        style="width:144px; height:144px; position:absolute; left:-144px; top:0;"
      ></div>
    </div>
    <iframe
      :src="tpUrl"
      frameborder="0"
      class="tp-frame"
      v-if="showTpLogin"
    ></iframe>
    <v-btn
      class="tp-frame-close"
      color="error"
      fab
      dark
      v-show="showTpLogin"
      @click="showTpLogin = false"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <button
      ref="loginTatapraja"
      id="loginTatapraja"
      @click="LoginTP"
      style="display:none"
    >
      login tp
    </button>
    <div ref="scriptContainer"></div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    forms: {
      _token: '',
      username: '',
      password: '',
    },
    captchaUrl: '',
    tpUrl: '',
    showTpLogin: false,
    tahun: new Date().getFullYear(),
    pilihanTahun: [
      new Date().getFullYear() + 1,
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
    ],
  }),
  mounted() {
    localStorage.setItem('tahun', new Date().getFullYear())
    this.tahun = localStorage.getItem('tahun')

    // this.GetTataPraja('/')
    this.tpUrl = this.$api.url + '/tp'

    let scr = document.createElement('script')
    scr.innerHTML = `window.addEventListener('message', (event) => {
      if (event.data.source && event.data.source == 'tatapraja') {
        sessionStorage.setItem('tpform', JSON.stringify(event.data));
        document.getElementById('loginTatapraja').click()
      }
    })`
    this.$refs.scriptContainer.appendChild(scr)
  },
  methods: {
    ...mapActions(['setMenu', 'setUser']),
    async GetTataPraja(url) {
      let d = await this.$api.get(this.$api.url + '/proxy' + url)
      this.captchaUrl = d.captchaUrl
      this.forms.token = d.token
    },
    ShowTataPraja() {
      this.showTpLogin = true
      this.tpUrl = this.$api.url + '/tp'
    },
    async LoginTP() {
      this.showTpLogin = false
      let f = sessionStorage.getItem('tpform')
      let ret = await this.$api.logintp(JSON.parse(f))
      if (ret.length) {
        localStorage.setItem('balaiId', ret[0].CityID)
        this.setUser(ret[0])
        var menu = await this.$api.call('Arch_SelMenu')
        this.setMenu(menu)
        this.$router.push({ name: 'Home' })
      }
    },
    async submit() {
      var ret = await this.$api.login(this.forms)
      if (ret.length) {
        localStorage.setItem('balaiId', ret[0].CityID)
        this.setUser(ret[0])
        var menu = await this.$api.call('Arch_SelMenu')
        this.setMenu(menu)
        this.$router.push({ name: 'Home' })
      }
    },
    tahunAnggaranClick(t) {
      localStorage.setItem('tahun', t)
      this.tahun = t
    },
  },
}
</script>
<style lang="scss">
// .theme--light.v-application {
//   background: #f3f3f3;
// }
.login-box {
  width: 300px;
  background: white;
  box-sizing: content-box;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  margin: auto;
  margin-top: 10%;
  text-align: center;
  overflow: hidden;
}
.tp-frame {
  width: 420px;
  max-width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0px;
  right: 0px;
  box-shadow: 0 0 20px grey;
  &-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
